import { ControlListProps, useTranslation } from "@bsm/component";

export const useInvoiceSignatoryCreateForm = (
    id?: number
): ControlListProps => {

    const t = useTranslation()

    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "text",
                    name: "name",
                    label: "Name",
                    required: true,
                },
                {
                    type: "text",
                    name: "fonction",
                    label: "Position",
                    required: true,
                },
                {
                    type: "drop-zone",
                    name: "signature",
                    accept: { "image/png": [".png"] },
                    label: "Signature",
                    required: true,
                },
            ],
            value: {},
            graphQL: {
                entity: "signatory",
                entityId: id,
            },
            next: {
                label: id ? "Save" : "Add",
                className: "btn btn-primary text-white",
            },
            back: {
                label: "Cancel",
            },
        },
        id: "invoice-signatory-form",
        onBeforeSaving: (value) => ({
            ...value,
            signature: { id: value.signature.id },
        }),
    };
};
